module.exports = __webpack_public_path__ + "img/cacib.c38f6f91.svg";